import React from "react";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";

const Appointments = ({ chartData }: any) => {
  // Prepare data with a combined date and time key
  const transformedData = chartData?.data?.appointmnetRevenue?.map((item: any) => ({
    ...item,
    appointmentDateTime: `${item.appointmentDate} ${item.appointmentTime}`,
  }));

  return (
    <>
      <div className="d-flex justify-content-between">
        <div>
          <span className="dashboard-heading mb-4">Appointments</span>
        </div>
      </div>
      <ResponsiveContainer width="100%" height={200}>
        <LineChart data={transformedData}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis
            dataKey="appointmentDateTime"
            type="category"
            tickFormatter={(tick) => {
              const [date, time] = tick.split(" ");
              return `${new Date(date).toLocaleDateString("en-US", {
                month: "short",
                day: "numeric",
              })}\n${time}`;
            }}
          />
          <YAxis
            dataKey="appointmentCount"
            type="number"
            label={{
              value: "Appointments",
              angle: -90,
              position: "insideLeft",
            }}
          />
          <Tooltip
            labelFormatter={(label) => {
              const [date, time] = label.split(" ");
              return `Date: ${new Date(date).toLocaleDateString("en-US", {
                month: "long",
                day: "numeric",
              })}, Time: ${time}`;
            }}
          />
          <Legend />
          <Line
            dataKey="appointmentCount"
            stroke="#8884d8"
            name="Appointments"
          />
        </LineChart>
      </ResponsiveContainer>
    </>
  );
};

export default Appointments;
